import { rgbToHex } from '@material-ui/core'
import _ from 'lodash'

const CLEAR_KEYS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 'source', 'useVideo', 'limitSize', 'customCSS', '--inline-pos']

const SEPARATE_BORDER_PROPS = [
  '--ft-border',
  ..._.flatMap(['borderTop', 'borderLeft', 'borderBottom', 'borderRight'], (key) => [
    `${key}Width`,
    `${key}Style`,
    `${key}Color`,
  ]),
]

export const getStyle = (style, isImportant = false, type) => {
  style = _.omit(style, CLEAR_KEYS)
  if (String(style?.fill).includes('function fill')) {
    delete style.fill
  }
  if (style.backgroundImage === 'none' || style.backgroundImage === "'none'") {
    style.backgroundImage = ''
  }
  _.each(
    _.filter(_.keys(style), (key) => _.endsWith(key, 'UnitUnit')),
    (key) => {
      _.unset(style, key)
    }
  )
  if (style.fontFamily) {
    style.fontFamily = String(style.fontFamily).replace('Open Sans Hebrew', 'Open Sans')
  }
  const retStyle = _.omit(style, [
    'active',
    'hover',
    'minHeightUnit',
    'maxHeightUnit',
    'heightUnit',
    'gridGapUnit',
    'minWidthUnit',
    'maxWidthUnit',
    'widthUnit',
    'paddingTopUnit',
    'paddingBottomUnit',
    'paddingLeftUnit',
    'paddingRightUnit',
    'marginTopUnit',
    'marginBottomUnit',
    'marginLeftUnit',
    'marginRightUnit',
    'flexBasisUnit',
    'borderWidthUnit',
    'borderWidth',
    'borderStyle',
    'borderColor',
    'lineHeightUnit',
    'shadow',
    'tShadow',
    'borderRadius',
    'topUnit',
    'leftUnit',
    'rightUnit',
    'bottomUnit',
    'letterSpacingUnit',
    '--row-gapUnit',
    '--row-gap-unit',
    '--drawer-widthUnit',
    '--btn-icon-widthUnit',
    '--btn-icon-heightUnit',
    ...(style?.['--ft-border'] ? ['borderWidth', 'borderStyle', 'borderColor', '--ft-border'] : SEPARATE_BORDER_PROPS),
  ])
  retStyle.fontFamily = _.trim(retStyle.fontFamily, ';')
  if (retStyle.fontFamily === '') {
    _.unset(retStyle, 'fontFamily')
  }
  retStyle['--rotate'] = getSizeProp(style, '--rotate', 'deg')
  retStyle['--drawer-width'] = getSizeProp(style, '--drawer-width', 'px')
  retStyle['--row-gap'] = getSizeProp(style, '--row-gap', 'px')
  retStyle['--grid-gap'] = getSizeProp(style, '--grid-gap', 'px')
  retStyle['--btn-icon-width'] = getSizeProp(style, '--btn-icon-width', 'px')
  retStyle['--btn-icon-width'] = getSizeProp(style, '--btn-icon-width', 'px')

  retStyle['--icon-margin-top'] = getSizeProp(style, '--btn-icon-margin-top', 'px')
  retStyle['--icon-margin-left'] = getSizeProp(style, '--btn-icon-margin-left', 'px')
  retStyle['--icon-margin-right'] = getSizeProp(style, '--btn-icon-margin-right', 'px')
  retStyle['--icon-margin-bottom'] = getSizeProp(style, '--btn-icon-margin-bottom', 'px')

  retStyle.letterSpacing = getSizeProp(style, 'letterSpacing', 'px')
  retStyle.lineHeight = getSizeProp(style, 'lineHeight', 'px')
  retStyle.fontSize = getSizeProp(style, 'fontSize', 'px')
  retStyle.height = getSizeProp(style, 'height')
  retStyle.minHeight = getSizeProp(style, 'minHeight')
  retStyle.maxHeight = getSizeProp(style, 'maxHeight')
  if (style.overflowX) {
    retStyle.overflowX = style.overflowX
  }
  if (style.overflowY) {
    retStyle.overflowY = style.overflowY
  }
  retStyle.width = getSizeProp(style, 'width')
  retStyle.minWidth = getSizeProp(style, 'minWidth')
  retStyle.maxWidth = getSizeProp(style, 'maxWidth')
  retStyle.paddingRight = getSizeProp(style, 'paddingRight')
  retStyle.paddingLeft = getSizeProp(style, 'paddingLeft')
  retStyle.paddingBottom = getSizeProp(style, 'paddingBottom')
  retStyle.paddingTop = getSizeProp(style, 'paddingTop')
  retStyle.marginRight = getSizeProp(style, 'marginRight')
  retStyle.marginTop = getSizeProp(style, 'marginTop')
  retStyle.marginLeft = getSizeProp(style, 'marginLeft')
  retStyle.marginBottom = getSizeProp(style, 'marginBottom')
  retStyle.flexBasis = getSizeProp(style, 'flexBasis')
  if (style?.['--ft-border']) {
    retStyle.borderTopWidth = getSizeProp(style, 'borderTopWidth', 'px')
    retStyle.borderRightWidth = getSizeProp(style, 'borderRightWidth', 'px')
    retStyle.borderBottomWidth = getSizeProp(style, 'borderBottomWidth', 'px')
    retStyle.borderLeftWidth = getSizeProp(style, 'borderLeftWidth', 'px')
    _.each(['borderWidth', 'borderStyle', 'borderColor', '--ft-border'], (key) => {
      _.unset(retStyle, key)
    })
  } else {
    retStyle.borderWidth = getSizeProp(style, 'borderWidth', 'px')
  }
  retStyle.gridGap = getSizeProp(style, 'gridGap')
  retStyle.top = getSizeProp(style, 'top')
  retStyle.left = getSizeProp(style, 'left')
  retStyle.right = getSizeProp(style, 'right')
  retStyle.bottom = getSizeProp(style, 'bottom')
  if (style.borderRadius) {
    if (/^[0-9]+$/.test(style.borderRadius)) {
      retStyle.borderRadius = `${style.borderRadius}px`
    } else {
      retStyle.borderRadius = style.borderRadius
    }
  }
  if (_.get(style, 'backgroundImage') && _.get(style, 'backgroundImage') != `''`) {
    retStyle.backgroundImage = `url(${_.get(style, 'backgroundImage')})`
  } else {
    delete retStyle.backgroundImage
  }
  let boxShadow = makeShadow(style)
  let textShadow = makeTextShadow(style)

  if (boxShadow) {
    retStyle.boxShadow = boxShadow
  }
  if (textShadow) {
    retStyle.textShadow = textShadow
  }
  // const border = getBorderStyle(style)
  // if (border) {
  //   retStyle.border = border
  // }
  if (_.get(style, 'stroke')) {
    _.set(retStyle, ['stroke'], _.get(style, 'stroke', ''))
  }
  if (_.get(style, 'fill')) {
    _.set(retStyle, ['fill'], String(_.get(style, 'fill', '')))
  }

  if (!style?.['--ft-border']) {
    if (_.get(style, 'borderStyle')) {
      retStyle.borderStyle = _.get(style, 'borderStyle', 'none')
    }
    if (_.get(style, 'borderColor')) {
      retStyle.borderColor = _.get(style, 'borderColor', '#000')
    }
  }
  if (isImportant) {
    _.each(retStyle, (val, key) => {
      if (val !== 'initial' && val !== 'unset') {
        retStyle[key] = `${val} !important`
      }
    })
  }
  if (_.has(style, 'hover')) {
    retStyle['&:hover'] = getStyle(_.get(style, 'hover', {}), isImportant)
    if (type && (type === 'Line' || type === 'Svg')) {
      _.set(retStyle, ['&:hover', 'backgroundColor'], _.get(style, 'hover.borderColor', ''))
    }
  }
  if (_.has(style, 'active')) {
    retStyle['&:active'] = getStyle(_.get(style, 'active', {}), isImportant)
    if (type && (type === 'Line' || type === 'Svg')) {
      _.set(retStyle, ['&:active', 'backgroundColor'], _.get(style, 'active.borderColor', ''))
    }
  }
  return _.omitBy(retStyle, (val, key) => val === 'initial' || val === 'unset' || typeof val === 'undefined')
}

export const getSizeProp = (style, key, defUnits, defVal) => {
  let val = style[key]
  if (!val && defVal) {
    val = defVal
  }
  let units = defUnits ? defUnits : _.get(style, `${key}Unit`, 'px')
  if (
    !Boolean(units) &&
    [
      'width',
      'height',
      'margin',
      'padding',
      'left',
      'top',
      'right',
      'bottom',
      'minHeight',
      'maxHeight',
      'minWidth',
      'maxWidth',
    ].indexOf(key) !== -1
  ) {
    units = 'px'
  }
  if (val === 'auto') {
    return 'auto'
  } else if (val === 'min-content') {
    return 'auto'
  } else if (val === 'max-content') {
    return 'max-content'
  } else if (units === 'calc') {
    return `calc(${val})`
  } else if (val) {
    if (_.isNaN(parseInt(val))) {
      return 'auto'
    } else {
      return `${parseInt(val)}${units}`
    }
  } else {
    return 'unset'
  }
}

export const makeShadowItem = (shadow) =>
  `${_.get(shadow, 'inset', false) ? 'inset' : ''} ${_.get(shadow, 'x', '0')}px ${_.get(shadow, 'y', '0')}px ${_.get(shadow, 'blur', '0')}px ${_.get(shadow, 'spread', '0')}px ${_.get(shadow, 'color', '#000')}`

export const makeShadow = (style) => _.map(_.get(style, 'shadow', []), makeShadowItem).join(',')

export const makeDropShadowFilter = (style) => {
  let shadow = _.get(style, 'shadow.0', {})
  return `${_.get(shadow, 'x', '0')}px ${_.get(shadow, 'y', '0')}px ${_.get(shadow, 'blur', '0')}px ${_.get(shadow, 'color', '#000')}`
}

export const makeTextShadowItem = (shadow) =>
  `${_.get(shadow, 'inset', false) ? 'inset' : ''} ${_.get(shadow, 'x', '0')}px ${_.get(shadow, 'y', '0')}px ${_.get(shadow, 'blur', '0')}px ${_.get(shadow, 'color', '#000')}`

export const makeTextShadow = (style) => _.map(_.get(style, 'tShadow', []), makeTextShadowItem).join(',')

const GOOGLE_EMAIL_STYLE = [
  'azimuth',
  'background',
  'backgroundBlendMode',
  'backgroundClip',
  'backgroundColor',
  'backgroundImage',
  'backgroundOrigin',
  'backgroundPosition',
  'backgroundRepeat',
  'backgroundSize',
  'border',
  'borderBottom',
  'borderBottomColor',
  'borderBottomLeftRadius',
  'borderBottomRightRadius',
  'borderBottomStyle',
  'borderBottomWidth',
  'borderCollapse',
  'borderColor',
  'borderLeft',
  'borderLeftColor',
  'borderLeftStyle',
  'borderLeftWidth',
  'borderRadius',
  'borderRight',
  'borderRightColor',
  'borderRightStyle',
  'borderRightWidth',
  'borderSpacing',
  'borderStyle',
  'borderTop',
  'borderTopColor',
  'borderTopLeftRadius',
  'borderTopRightRadius',
  'borderTopStyle',
  'borderTopWidth',
  'borderWidth',
  'boxSizing',
  'breakAfter',
  'breakBefore',
  'breakInside',
  'captionSide',
  'clear',
  'color',
  'columnCount',
  'columnFill',
  'columnGap',
  'columnRule',
  'columnRuleColor',
  'columnRuleStyle',
  'columnRuleWidth',
  'columnSpan',
  'columnWidth',
  'columns',
  'direction',
  'display',
  'elevation',
  'emptyCells',
  'float',
  'font',
  'fontFamily',
  'fontFeatureSettings',
  'fontKerning',
  'fontSize',
  'fontSizeAdjust',
  'fontStretch',
  'fontStyle',
  'fontSynthesis',
  'fontVariant',
  'fontVariantAlternates',
  'fontVariantCaps',
  'fontVariantEastAsian',
  'fontVariantLigatures',
  'fontVariantNumeric',
  'fontWeight',
  'height',
  'imageOrientation',
  'imageResolution',
  'imeMode',
  'isolation',
  'layoutFlow',
  'layoutGrid',
  'layoutGridChar',
  'layoutGridCharSpacing',
  'layoutGridLine',
  'layoutGridMode',
  'layoutGridType',
  'letterSpacing',
  'lineBreak',
  'lineHeight',
  'listStyle',
  'listStylePosition',
  'listStyleType',
  'margin',
  'marginBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'markerOffset',
  'maxHeight',
  'maxWidth',
  'minHeight',
  'minWidth',
  'mixBlendMode',
  'objectFit',
  'objectPosition',
  'opacity',
  'outline',
  'outlineColor',
  'outlineStyle',
  'outlineWidth',
  'overflow',
  'overflowX',
  'overflowY',
  'padding',
  'paddingBottom',
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'pageBreakAfter',
  'pageBreakBefore',
  'pageBreakInside',
  'pause',
  'pauseAfter',
  'pauseBefore',
  'pitch',
  'pitchRange',
  'quotes',
  'richness',
  'speak',
  'speakHeader',
  'speakNumeral',
  'speakPunctuation',
  'speechRate',
  'stress',
  'tableLayout',
  'textAlign',
  'textAlignLast',
  'textAutospace',
  'textCombineUpright',
  'textDecoration',
  'textDecorationColor',
  'textDecorationLine',
  'textDecorationSkip',
  'textDecorationStyle',
  'textEmphasis',
  'textEmphasisColor',
  'textEmphasisStyle',
  'textIndent',
  'textJustify',
  'textKashidaSpace',
  'textOrientation',
  'textOverflow',
  'textTransform',
  'textUnderlinePosition',
  'unicodeBidi',
  'verticalAlign',
  'voiceFamily',
  'whiteSpace',
  'width',
  'wordBreak',
  'wordSpacing',
  'wordWrap',
  'writingMode',
  'zoom',
]

export const fixEmailColors = (style) => {
  let outStyles = Object.assign({}, style)
  _.each(outStyles, (v, k) => {
    if (k === 'fontFamily') {
      outStyles[k] = _.trim(v, ';').replace(/"|'/g, '')
    }
    if (['color', 'background', 'backgroundColor', 'borderColor', 'fontColor'].includes(k)) {
      try {
        if (_.startsWith(v, 'rgb')) {
          outStyles[k] = rgbToHex(v)
        } else if (_.startsWith(v, '#') && String(v).length === 9) {
          outStyles[k] = String(v).substring(0, 7)
        }
      } catch (error) {}
    } else if (k === 'chartColor') {
      delete outStyles[k]
    }
  })
  return _.reduce(
    _.pick(outStyles, GOOGLE_EMAIL_STYLE),
    (r, v, k) => ({
      ...r,
      ...(Boolean(v) ? { [k]: v } : {}),
    }),
    {}
  )
}
